/**
 * Created by ivo on 06.05.14.
 */

define([
    'common',
    'jQuery',
    './widgetFactory',
    'clientComponents/hotelimages/hotelimages',
    'clientComponents/hoteldetails/hoteldetails',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-state/urlHandling',
    'library/fcse-state/Scope',
    'clientComponents/offerlist/offerList',
    'clientComponents/hotelReviews/hotelreviews',
    'library/fcse-content/tabs',
    'clientComponents/youtubemodal/youtubeModal',
    'clientComponents/giatavideomodal/giataVideoModal',
    'clientComponents/simplevideo/simplevideo',
    'clientComponents/map/mapModal',
    'library/fcse-util/url',
    'clientComponents/offervaliditycheck/directOfferValidityCheck',
    'clientComponents/googletagmanager/GtmManager'
    ],
    function (common,
              $,
              WidgetFactory,
              HotelImages,
              HotelDetails,
              MultiRequestHandler,
              UrlHandling,
              Scope,
              OfferList,
              HotelReviews,
              Tabs,
              YoutubeModal,
              GiataVideoModal,
              SimpleVideo,
              MapModal,
              Url,
              DirectOfferValidityCheck,
              GtmManager
    ) {
        var params = {};
        var url = new Url();

        if (typeof window.productSearchParams !== 'undefined') {
            params = window.productSearchParams;
        }
        // Create scopes
        var rootScope = new Scope(null, null, null, params);
        var localScope = new Scope(rootScope);

        localScope.setParam('bookingType', 'package');

        // Initialize ajax request handler
        var requestHandler = new MultiRequestHandler();

        // Create widget factory
        var widgetFactory = new WidgetFactory({rootScope: rootScope, localScope : localScope});

        // Enable URL History
        if (typeof history.pushState != 'undefined') {
            UrlHandling.enableBrowserHistory(rootScope);
        }

        if ($('[data-fcse-role="gallery"]').length > 0) {
            // Initialize gallery
            var hotelImages = new HotelImages({'zoomSelector': '.slider--container, [data-fcse-role="gallery--sliderzoom"]'});
        }

        var hotelDetails = new HotelDetails({element: $('[data-fcse-role="hotel-details"]')});

        // Initialize OfferList
        var offerList = new OfferList('[data-fcse-role="offerlist"]', requestHandler, rootScope, {
            offersRoute: 'allt_frontend.package.detail.offers',
            offersCheckRoute: 'allt_frontend.package.detail.offer_check'
        });

        var reviews = new HotelReviews('[data-fcse-role="hotel-reviews"]', rootScope, {});

        var tabs = new Tabs('.accordion-country--sidebar', '.accordion-country--tab-content', {});

        var youtubeModal = new YoutubeModal('[data-fcse-role="youtubemodal"]');
        var giataVideoModal = new GiataVideoModal('[data-fcse-role="giata-video-modal"]');
        var video = new SimpleVideo('[data-fcse-role="media--video-container"]');
        var zooverBadge = $('#zoover-badge');

        var mapModal = MapModal.getInstance($('[data-fcse-role="map-modal"]'), requestHandler, {});
        $('[data-fcse-role="map-overlay-open-button"]', this.element).click(function() {
            mapModal.open(
              $(this).data('id'),
              $('#offerlist [data-map-product-search]').data('map-product-search'),
              $(this).data('fallback-center'),
              $(this).attr('data-map-country-name'),
              $(this).data('map-hotel-id')
            );
        });

        if (!_.isUndefined(url.query.showmap) && url.query.showmap == 'true' && !_.isUndefined(url.query.groupNames)) {
            var mapOpenButton = $('[data-fcse-role="map-overlay-open-button"]:first', this.element);

            if (mapOpenButton.length){
                mapOpenButton.click();
            }
        }

        if (zooverBadge.length && zooverBadge.data('zoover-deeplink') && (typeof window.CreateButtonBadge) == 'function') {
            window.CreateButtonBadge(zooverBadge.data('zoover-deeplink'), 'alltours', 1, 'zoover-badge');
        }

        DirectOfferValidityCheck.init();

        try{
            GtmManager
                .setOptions({scope: rootScope, stateHandler: requestHandler})
                .initPageTracker('productPage', {
                    country: $('[data-page-locale]').first().data('page-locale'),
                    pageType: 'productPage',
                    siteArea: 'packageDetail'
                });
        } catch (e) {
            console.log(e);
        }
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/pages/package/detail/index.js